import ErrorIcon from "assets/error-icon.svg";
import ClaimsEmpty from "assets/claims_empty.svg";
import DocumentsEmpty from "assets/documents-empty.svg";
import DocIcon from "assets/doc-icon.svg";
import ErrorDocs from "assets/error-docs.svg";
import GetCare from "assets/Get Care.svg";
import EmptyHistory from "assets/empty_history.svg";
import RemoveWarning from "assets/remove-warning.svg";

// Wired into LeagueConfig.assets.overrides; consumed by WebCommonErrorState
// via handleStaticAsset(WEB_COMMON_ASSET_KEYS.WEB_COMMON_ERROR_STATE_IMAGE).
export const ASSET_OVERRIDES = {
  WEB_COMMON_ERROR_STATE_IMAGE: ErrorIcon,
  ERROR_STATE_COVER: ErrorIcon,
  CLAIMS_LIST_EMPTY: ClaimsEmpty,
  EMPTY_STATE_ICON: DocumentsEmpty,
  ERROR_STATE_ICON: ErrorDocs,
  CARE_DOCUMENT_ICON: DocIcon,
  FILE_UPLOAD_ICON: GetCare,
  EMPTY_STATE_HISTORY: EmptyHistory,
  REMOVE_ACTIVITY_IMAGE: RemoveWarning,
  REMOVE_PROGRAM_IMAGE: RemoveWarning,
};
